import { provideHttpClient } from "@angular/common/http";
import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router } from '@angular/router';
import { ApplicationType, ENV, HttpService, ServiceType } from '@danangelus/ngx-app-core';
import Aura from '@primeuix/themes/aura';
import { CookieService } from 'ngx-cookie-service';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { AuthenticationInterceptor } from './core/security/authentication.interceptor';
import { SessionService } from './core/security/session.service';
import { LoaderService } from './core/services/loader.service';

function setup(loaderService: LoaderService) {
    //Configure location of configuration-services on all hosts
    ENV.configServiceHostMap = {
        'localhost:4200': 'http://localhost:8601',
        'localhost': 'http://localhost:8601',
        '192.168.1.77': 'http://192.168.1.77/gateway-app-manager',
        '10.15.70.7': 'https://10.15.70.7/gateway-app-manager',
        '10.15.70.8': 'https://10.15.70.8/gateway-app-manager',
        'sgb-gateway.tier2consulting.uk': 'https://sgb-services.tier2consulting.uk/gateway-app-manager',
        'uatgw.suzuki.co.uk': 'https://uatgw.suzuki.co.uk/gateway-app-manager',
        'gw.suzuki.co.uk': 'https://gw.suzuki.co.uk/gateway-app-manager',
    }

    // Enumeration of all the exposed services
    ServiceType.APP_MANAGER = 'APP_MANAGER'
    ServiceType.LDAP_MANAGER = 'LDAP_MANAGER'
    ServiceType.NOTIFICATION = 'NOTIFICATION'
    ServiceType.SSO = 'SSO'

    // Enumeration of all the web applications
    ApplicationType.GATEWAY = 'GATEWAY'

    return () => loaderService.initialiseApp()
}

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: setup,
            deps: [LoaderService],
            multi: true
        },
        {
            provide: HttpService,
            useFactory: (
                router: Router,
                sessionService: SessionService,
                cookieService: CookieService,
            ) => {
                const httpService = new HttpService()
                httpService.handleErrors = false
                httpService.interceptors = [
                    new AuthenticationInterceptor(router, sessionService, cookieService)
                ]
                return httpService
            },
            deps: [
                Router,
                SessionService,
                CookieService,
            ]
        },
        provideRouter(routes),
        provideZoneChangeDetection({ eventCoalescing: false }),
        provideAnimations(),
        provideHttpClient(),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'primeng, app-styles'
                    }
                }
            },
        })
    ]
}
